var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.191,
    height: 52.3,
    viewBox: "0 0 70.191 52.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.192 13.765H6a6.007 6.007 0 0 1-6-6V6a6.007 6.007 0 0 1 6-6h58.192a6.007 6.007 0 0 1 6 6v1.764a6.007 6.007 0 0 1-6 6.001zM53.676 4.819v4.816h11.01V4.819z",
    transform: "translate(-964 -531.999) translate(964 531.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.192 13.765H6a6.007 6.007 0 0 1-6-6V6a6.007 6.007 0 0 1 6-6h58.192a6.007 6.007 0 0 1 6 6v1.764a6.007 6.007 0 0 1-6 6.001zm-27.72-8.946v4.816h28.214V4.819z",
    transform: "translate(-964 -531.999) translate(964 551.266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.192 13.765H6a6.007 6.007 0 0 1-6-6V6a6.007 6.007 0 0 1 6-6h58.192a6.007 6.007 0 0 1 6 6v1.764a6.007 6.007 0 0 1-6 6.001zM50.235 4.819v4.816h14.45V4.819z",
    transform: "translate(-964 -531.999) translate(964 570.534)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsFilled);
export default __webpack_public_path__ + "static/media/reports-filled.deeafbe60aa3fb8ade40633c1e700419.svg";
export { ForwardRef as ReactComponent };